module.exports = __webpack_public_path__ + "img/mobile/BetBar/Menu_button@1x.png?0.0.53";